import React from "react";
import { Redirect, Route } from "react-router-dom";
import * as FeatherIcon from "react-feather";

import { store } from "../redux/store";

// dashboard
const Dashboard = React.lazy(() => import("../pages/dashboard/Dashboard"));

// Payment
const Payment = React.lazy(() => import("../pages/payment/Payment"));
const DetailPayment = React.lazy(() => import("../pages/payment/DetailPayment"));

const Prefunds = React.lazy(() => import("../pages/prefund/presentation/Prefunds"));
const DetailPrefunds = React.lazy(() => import("../pages/prefund/presentation/Detail"));

// Deposit
const Deposit = React.lazy(() => import("../pages/deposit/Deposit"));

// auth
const Login = React.lazy(() => import("../pages/auth/Login"));
const Logout = React.lazy(() => import("../pages/auth/Logout"));

// 404
const NotFound = React.lazy(() => import("../pages/other/Error404"));

// handle auth and authorization
const PrivateRoute = ({ component: Component, roles, ...rest }) => {
    const { user } = store.getState().Auth;
    return (
        <Route
            {...rest}
            render={(props) => {
                if (user === null) {
                    // not logged in so redirect to login page with the return url
                    return <Redirect to={{ pathname: "/account/login", state: { from: props.location } }} />;
                }

                // const loggedInUser = getLoggedInUser();
                // // check if route is restricted by role
                // if (roles && roles.indexOf(loggedInUser.role) === -1) {
                //     // role not authorised so redirect to home page
                //     return <Redirect to={{ pathname: '/' }} />;
                // }

                // authorised so return component
                return <Component {...props} />;
            }}
        />
    );
};

// root routes
const rootRoute = {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
    route: PrivateRoute,
};

// not found route
const notFoundRoute = {
    path: "*",
    exact: true,
    component: NotFound,
    route: Route,
};

// dashboard
const dashboardRoutes = {
    path: "/dashboard",
    exact: true,
    name: "Dashboard",
    icon: FeatherIcon.Home,
    component: Dashboard,
    roles: ["Admin"],
    route: PrivateRoute,
};

// payment routes
const paymentRoutes = {
    lender_type: "1",
    path: "/payment",
    exact: true,
    name: "Pembayaran",
    icon: FeatherIcon.Pocket,
    component: Payment,
    roles: ["Admin"],
    route: PrivateRoute,
};

const paymentDetailRoutes = {
    path: "/payment/detail/:loanId",
    exact: true,
    component: DetailPayment,
    roles: ["Admin"],
    route: PrivateRoute,
};

// prefund routes
const prefundRoutes = {
    path: "/prefund",
    exact: true,
    name: "Pra-Pencairan",
    icon: FeatherIcon.Briefcase,
    component: Prefunds,
    roles: ["Admin"],
    route: PrivateRoute,
};

const prefundDetailRoutes = {
    path: "/prefund/:loanId",
    exact: true,
    component: DetailPrefunds,
    roles: ["Admin"],
    route: PrivateRoute,
};

// deposit routes
const depositRoutes = {
    lender_type: "2",
    path: "/deposit",
    exact: true,
    name: "Deposit",
    icon: FeatherIcon.CreditCard,
    component: Deposit,
    roles: ["Admin"],
    route: PrivateRoute,
};

// auth
const authRoutes = {
    path: "/account",
    exact: true,
    name: "Auth",
    children: [
        {
            path: "/account/login",
            exact: true,
            name: "Login",
            component: Login,
            route: Route,
        },
        {
            path: "/account/logout",
            exact: true,
            name: "Logout",
            component: Logout,
            route: Route,
        },
    ],
};

// flatten the list of all nested routes
const flattenRoutes = (routes) => {
    let flatRoutes = [];

    routes = routes || [];
    routes.forEach((item) => {
        flatRoutes.push(item);

        if (typeof item.children !== "undefined") {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};

// All routes
const allRoutes = [
    rootRoute,
    dashboardRoutes,
    prefundRoutes,
    prefundDetailRoutes,
    paymentRoutes,
    paymentDetailRoutes,
    depositRoutes,
    authRoutes,
    notFoundRoute,
];

const authProtectedRoutes = [dashboardRoutes, prefundRoutes,prefundDetailRoutes, paymentRoutes, paymentDetailRoutes, depositRoutes];
const allFlattenRoutes = flattenRoutes(allRoutes);
export { allRoutes, authProtectedRoutes, allFlattenRoutes };
